<template>
	<div class="container-wrapper">
<go-back v-if="!$store.state.isMobile" v-model="user" url="/admin/user-approval-list" label="Back" :backToList="true"></go-back>
<b-container class="user-add-container user-add-container-mobile" v-if="user != null && loaded">
	<div v-if="user.userId.value != null">
		<h1>Already Approved</h1>
		<div>Login: <strong>{{user.username.value}}</strong></div>
		<div>Name: {{user.firstName.value}} {{user.lastName.value}}</div>
		<div>Email: <a :href="'mailto:'+user.email.value">{{user.email.value}}</a></div>
		<div v-html="'Organization: '+getFlatTree(user.organizationId.value)"></div>
	</div>

<b-form @submit="onSubmit" @reset="onReset" v-if="user.userId.value == null">
	<div v-show="user.isApproved.value == null">
	<h1 class="page-title inner-page" v-show="!showNewPrimary">Approve or Reject New User Account</h1>
	<h1 class="page-title inner-page" v-show="showNewPrimary">Approve or Reject New Organization and User Account</h1>
	</div>
	<div v-show="user.isApproved.value == 0">
		<h1 v-show="!showNewPrimary">Status: Rejected</h1>
		<h1 v-show="showNewPrimary">Status: Rejected</h1>
	</div>
	<b-row v-show="showNewPrimary">
		<b-col>
			<b-form-group label="Create New Primary Organization"
				:state="user.name.status"
				:invalid-feedback="user.name.invalidMessage"
			>
			<b-form-input placeholder="" v-model="user.name.value"
				:state="user.name.status"
				@input="user.name.resetStatus()"
			></b-form-input>
			</b-form-group>

			<b-button v-show="canCreatePrimaryOrg()" @click="togglePrimary();" class="mb-3">Assign New User to Existing Organization Instead</b-button>
		</b-col>
	</b-row>
	<b-row v-show="showNewPrimary">
		<b-col>
			<b-form-group v-if="false" label="Organization Domain Name"
				:state="user.domain.status"
				:invalid-feedback="user.domain.invalidMessage"
			>
			<b-input-group prepend="@">
				<b-form-input placeholder="mycompany" v-model="user.domain.value"></b-form-input>
			</b-input-group>
			</b-form-group>
			<b-form-group label="Organization Domain Name"
				@click="focusDomainField"
				:state="organizationPrefix.status"
				:invalid-feedback="organizationPrefix.invalidMessage"
				class="lc__domain"
			>
			<p>The Organization Domain Name is added to the end of user logins and is required.  You can use the full name of your company, an abbreviated version or something memorable.<br/><br/>For example: user@<strong>example.com</strong> or user@<strong>example</strong> or user@<strong>expl</strong></p>

				<div @click="focusDomainField" id="domain-editable-content" class="form-control">
					<span id="domain-prefix" class="non-editable">@</span>
					<span id="domain-postfix" class="editable" @keydown="handleLCKeypress" @focus="setDomainFocusStyle" @blur="removeDomainFocus" @input="setNewDomain" contenteditable="true" v-html="organizationPrefix.value"></span>
				</div>
			</b-form-group>

		</b-col>
	</b-row>



		<b-row v-show="!showNewPrimary ">
			<b-col>
				<b-form-group label="Select Organization or Group"
					:state="user.organizationId.status"
					:invalid-feedback="user.organizationId.invalidMessage"
				>
				<vue-select-grouped v-model="user.organizationId.value" :canDelete="false"  :options="organizations" label="name" :reduce="name => name.id" @input="setOrganization">
					<template v-slot:option="optionGroup" :option="(typeof option === 'object')?option:{[name]: option, namePath:option.namePath, name:option.name, groupName:option.groupName}">
					</template>
					<template v-slot:option="option">
						<span :class="getLevelClassName(option.level)">{{ option.name }}</span>
					</template>
					<template v-slot:selected-option-container="option" :option="(typeof option === 'object')?option:{[name]: option, namePath:option.namePath, name:option.name}">
						<div class="vs__selected-options" v-html="getFlatTree(option.option)"></div>
					</template>
				</vue-select-grouped>
				</b-form-group>

				<b-button v-show="canCreatePrimaryOrg()" @click="togglePrimary();" class="mb-3">Create New Primary Organization Instead</b-button>

			</b-col>
		</b-row>



		<b-row>
		<b-col lg="4">

				<b-form-group label="Username"
					@click="focusUsernameField"
					:state="usernamePrefix.status"
					:invalid-feedback="usernamePrefix.invalidMessage"
					class="lc__username"
				>
					<p class="username-info">The user name must end with <strong>{{ organizationSuffix }}</strong>.<br/>Please enter the beginning of the user name.</p>
					<div @click="focusUsernameField" id="username-editable-content" class="form-control">
						<span id="username-prefix" class="editable" @keydown="handleLCKeypress" @focus="setFocusStyle" @blur="removeUsernameFocus" @input="setNewUsername" contenteditable="true" v-html="usernamePrefix.value"></span>
						<span id="username-postfix" class="non-editable">{{ organizationSuffix }}</span>
					</div>
				</b-form-group>

				<b-form-group label="Enter New Password if required (user has already set it)"
					:state="user.password.status"
					:invalid-feedback="user.password.invalidMessage"
				>
				<b-input-group>
				<b-form-input
					v-model="user.password.value"
					id="password"
					:strength="passwordStrength"
					:type="passwordFieldType"
					@input="updatePasswordStrength"
					autocomplete="off"
				/>
				<b-input-group-append>
				<b-button variant="secondary" @click="switchPasswordVisibility()">show/hide</b-button>
				</b-input-group-append>
				</b-input-group>
				</b-form-group>


				<b-form-group label="First Name"
					:state="user.firstName.status"
					:invalid-feedback="user.firstName.invalidMessage"
				>
				<b-form-input placeholder="First Name" v-model="user.firstName.value"
					:state="user.firstName.status"
					@input="user.firstName.resetStatus()"
				></b-form-input>
				</b-form-group>


				<b-form-group label="Last Name"
					:state="user.lastName.status"
					:invalid-feedback="user.lastName.invalidMessage"
				>
				<b-form-input placeholder="Last Name" v-model="user.lastName.value"
					:state="user.lastName.status"
					@input="user.lastName.resetStatus()"
				></b-form-input>
				</b-form-group>

				<b-form-group label="Title"
					:state="user.title.status"
					:invalid-feedback="user.title.invalidMessage"
				>
				<b-form-input placeholder="Title" v-model="user.title.value"
					:state="user.title.status"
					@input="user.title.resetStatus()"
				></b-form-input>
				</b-form-group>

				<b-form-group label="Email Address"
					:state="user.email.status"
					:invalid-feedback="user.email.invalidMessage"
				>
				<b-form-input type="email" placeholder="Email Address" v-model="user.email.value"
					:state="user.email.status"
					@input="user.email.resetStatus()"
				></b-form-input>
				</b-form-group>
				<b-form-group v-if="false" label="Is Email Address Confirmed?"
					:state="user.isEmailConfirmed.status"
					:invalid-feedback="user.isEmailConfirmed.invalidMessage"
					id="fg-is-email-confirmed"
					class="fg-is-email-confirmed"
				>
					<b-form-radio-group
						id="rg-is-email-confirmed"
						v-model="user.isEmailConfirmed.value"
						:options="User.getEmailConfirmedOptions"
						@change="user.isEmailConfirmed.resetStatus()"
						:state="user.isEmailConfirmed.status"
					>
					</b-form-radio-group>
				</b-form-group>


				<b-form-group label="Primary Phone"
					:state="user.phone.status"
					:invalid-feedback="user.phone.invalidMessage"
				>
				<b-input id="editUserRequestUserPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onPhoneFocus" @blur="onPhoneBlur" v-model="user.phone.value" placeholder="1-###-###-####"/>


				</b-form-group>


				<b-form-group label="Alternate Phone"
					:state="user.altPhone.status"
					:invalid-feedback="user.altPhone.invalidMessage"
				>
				<b-input id="editAppUserRequestUserAltPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onAltPhoneFocus" @blur="onAltPhoneBlur" v-model="user.altPhone.value" placeholder="1-###-###-####"/>
				</b-form-group>
			</b-col>
			<b-col lg="4">

			<b-form-group
			id="ig-supervisor"
			label="Supervisor"
			label-for="input-lcr-supervisor"
			description=""
			:state="selectSupervisor.status"
			:invalid-feedback="selectSupervisor.invalidMessage"
			>
				<div v-if="supervisor" class="contact">
					<div class="contact__name">{{supervisor.firstName}} {{supervisor.lastName}}</div>
					<div class="contact__organization">{{supervisor.organizationName}}</div>
					<div class="contact__phone">{{supervisor.phone}}</div>
					<b-button variant="light-blue" type="button" class="btn-sm mt-1 mb-2" @click="onRemoveSupervisor()">Remove</b-button>
				</div>
				<autocomplete
				:search="SearchSupervisor"
				:get-result-value="SearchSupervisorValue"
				@submit="HandleSelectSupervisor"
				placeholder="Start typing to select Supervisor"
				aria-label="Start typing to select Supervisor"
				ref="searchSupervisor"
				auto-select
				>
					<template v-slot:result=" {result, props } ">
					<li v-bind="props" class="autocomplete-result supervisor-result">
						<div class="contact-name">{{result.firstName}} {{result.lastName}}</div>
						<div class="contact-organization">{{result.organizationName}}</div>
						<div class="contact-phone">{{result.phone}}</div>
					</li>
				</template>
				</autocomplete>
			</b-form-group>

				<b-form-group
				id="ig-alternate"
				label="Alternate Contact"
				label-for="input-lcr-alternate"
				description=""
				:state="selectAlternate.status"
				:invalid-feedback="selectAlternate.invalidMessage"
				>
				<div v-if="alternateContact" class="contact">
					<div class="contact__name">{{alternateContact.firstName}} {{alternateContact.lastName}}</div>
					<div class="contact__organization">{{alternateContact.organizationName}}</div>
					<div class="contact__phone">{{alternateContact.phone}}</div>
					<b-button variant="light-blue" type="button" class="btn-sm mt-1 mb-2" @click="onRemoveAlternateContact()">Remove</b-button>
				</div>
					<autocomplete
					:search="SearchAlternate"
					:get-result-value="SearchAlternateValue"
					@submit="HandleSelectAlternate"
					placeholder="Start typing to select Alternate Contact"
					aria-label="Start typing to select Alternate Contact"
					ref="searchAlternate"
					auto-select
					>
						<template v-slot:result=" {result, props } ">
						<li v-bind="props" class="autocomplete-result alternate-result">
							<div class="contact-name">{{result.firstName}} {{result.lastName}}</div>
							<div class="contact-organization">{{result.organizationName}}</div>
							<div class="contact-phone">{{result.phone}}</div>
						</li>
					</template>
					</autocomplete>
				</b-form-group>

				<b-form-group v-if="false" label="Is user away?"
					:state="user.isAway.status"
					:invalid-feedback="user.isAway.invalidMessage"
					id="fg-is-away"
					class="fg-is-away"
				>
					<b-form-radio-group
						id="rg-is-away"
						v-model="user.isAway.value"
						:options="User.getYesNoUserAwayOptions"
						@change="user.isAway.resetStatus()"
						:state="user.isAway.status"
					>
					</b-form-radio-group>
				</b-form-group>

				<b-form-group label="Lane Closures Role" v-if="canSetRoles()">
					<b-form-checkbox-group
					v-model="user.roles.value"
					name="roles"
					stacked
					>
						<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[0].id)" :value="{id: User.getRoleOptions[0].id}" :checked="checkRole(User.getRoleOptions[0].id)"><span>{{User.getRoleOptions[0].name}}</span></b-form-checkbox>
						<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[1].id)" :value="{id: User.getRoleOptions[1].id}" :checked="checkRole(User.getRoleOptions[1].id)"><span>{{User.getRoleOptions[1].name}}</span></b-form-checkbox>
						<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[2].id)" :value="{id: User.getRoleOptions[2].id}" :checked="checkRole(User.getRoleOptions[2].id)"><span>{{User.getRoleOptions[2].name}}</span></b-form-checkbox>
						<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[3].id)" :value="{id: User.getRoleOptions[3].id}" :checked="checkRole(User.getRoleOptions[3].id)"><span>{{User.getRoleOptions[3].name}}</span></b-form-checkbox>
						<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[4].id)" :value="{id: User.getRoleOptions[4].id}" :checked="checkRole(User.getRoleOptions[4].id)"><span>{{User.getRoleOptions[4].name}}</span></b-form-checkbox>
						<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[5].id)" :value="{id: User.getRoleOptions[5].id}" :checked="checkRole(User.getRoleOptions[5].id)"><span>{{User.getRoleOptions[5].name}}</span></b-form-checkbox>
						<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[6].id)" :value="{id: User.getRoleOptions[6].id}" :checked="checkRole(User.getRoleOptions[6].id)"><span>{{User.getRoleOptions[6].name}}</span></b-form-checkbox>
					</b-form-checkbox-group>
				</b-form-group>

				<b-form-group label="Lane Closures Role" v-if="!canSetRoles()">
				<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[0].id)"><span>{{User.getRoleOptions[0].name}}</span></div>
				<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[1].id)"><span>{{User.getRoleOptions[1].name}}</span></div>
				<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[2].id)"><span>{{User.getRoleOptions[2].name}}</span></div>
				<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[3].id)"><span>{{User.getRoleOptions[3].name}}</span></div>
				<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[4].id)"><span>{{User.getRoleOptions[4].name}}</span></div>
				<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[5].id)"><span>{{User.getRoleOptions[5].name}}</span></div>
				<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[6].id)"><span>{{User.getRoleOptions[6].name}}</span></div>
				</b-form-group>
		</b-col>
			</b-row>





			<b-row>
				<b-col class="pt-3"><h2>2. Important / Recommended Notifications</h2></b-col>
			</b-row>
			<b-row>
				<b-col>
					<p>Winnipeg Lane Closures will send you notifications about the status of your lane closure requests.
					</p>
					<p><strong>Email notifications</strong>: Please check your trash or spam mailbox when email notifications are sent.</p>
					<p class="web-only"><strong>Push notifications</strong>:  Install the Winnipeg Lane Closures mobile app to have push notifications sent to your Android or IOS device.</p>
					<p class="app-only"><strong>Push notifications</strong>:  Turn ON have push notifications sent to your Android or IOS device.</p>
					<p v-if="!hideWeb"><strong>Web notifications</strong>: We recommend City of Winnipeg administrators turn Web notifications <strong>ON</strong> if you frequently use Winnipeg Lane Closures.</p>
					<p>Receive these notifications when you are the requester or a contact for a lane closure request.<br/>
					Activate the <strong>Include requests NOT assigned to me</strong> checkbox to ALSO receive notifications about  requests assigned to other people in your organization.</p>
				</b-col>
			</b-row>

			<b-row>
				<b-col>
				<div class="collapsible text-primary">
			<div class="collapse--content collapse show">
			<b-col class="mb-3">
				<user-notification-setting :setting="'lcr-new-message'" :hideWeb="hideWeb" :forceEmail="true" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
				<user-notification-setting :setting="'lcr-approved'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
				<user-notification-setting :setting="'lc-not-opened'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
				<user-notification-setting :setting="'new-contravention'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
			</b-col>
			</div>
			</div>
			</b-col>
			</b-row>


			<b-row>
				<b-col class="pt-3"><h2>3. Additional Notifications</h2>
					<p>Expand each of the sections below and choose your preferences.</p>
				</b-col>
			</b-row>

			<b-row>
				<b-col>
					<div :class="collapseLcrUpdateNotifications ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
						<template>
							<div class="collapsible-heading p-0">
								<div class="d-flex flex-nowrap bottom-border">
									<div class="collapsible-heading__value" @click="collapseLcrUpdateNotifications = !collapseLcrUpdateNotifications">
										Updates to Status or Details
									</div>

									<div class="collapsible-heading__toggle">
										<b-button href="#" variant="collapsible" :class="collapseLcrUpdateNotifications ? '' : ' collapsed'" :aria-expanded="collapseLcrUpdateNotifications ? 'true' : 'false'" aria-controls="collapseLcrUpdateNotifications" @click="collapseLcrUpdateNotifications = !collapseLcrUpdateNotifications">
											<span class="when-opened">
												<font-awesome-icon icon="chevron-down" />
											</span>
											<span class="when-closed">
												<font-awesome-icon icon="chevron-right" />
											</span>
										</b-button>
									</div>
								</div>
							</div>
							<b-collapse id="collapseLcrUpdateNotifications" :visible="collapseLcrUpdateNotifications" class="collapse--content">
								<b-col class="mb-3">
									<user-notification-setting :setting="'lcr-updated'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'lcr-denied'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'lcr-completed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'lcr-cancelled'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'lcr-contact-added'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'lcr-contact-removed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'new-lcr'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								</b-col>
							</b-collapse>
						</template>
					</div>
				</b-col>
			</b-row>

				<b-row>
					<b-col>
						<div :class="collapseReminders ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
							<template>
								<div class="collapsible-heading p-0">
									<div class="d-flex flex-nowrap bottom-border">
										<div class="collapsible-heading__value" @click="collapseReminders = !collapseReminders">
											Reminders
										</div>
										<div class="collapsible-heading__toggle">
											<b-button href="#" variant="collapsible" :class="collapseReminders ? '' : ' collapsed'" :aria-expanded="collapseReminders ? 'true' : 'false'" aria-controls="collapseReminders" @click="collapseReminders = !collapseReminders">
												<span class="when-opened">
													<font-awesome-icon icon="chevron-down" />
												</span>
												<span class="when-closed">
													<font-awesome-icon icon="chevron-right" />
												</span>
											</b-button>
										</div>
									</div>
								</div>
								<b-collapse id="collapseReminders" :visible="collapseReminders" class="collapse--content">
									<b-col class="mb-3 mt-3">
										Be reminded when you should report lanes closed at the start time and re-opened at the completion time.
									</b-col>
									<b-col class="mb-3">
									<user-notification-setting :setting="'lc-reminder-close'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'lc-reminder-open'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'r-reminder-place'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'r-reminder-remove'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									</b-col>
								</b-collapse>
							</template>
						</div>
					</b-col>
				</b-row>


				<b-row>
					<b-col>
						<div :class="collapseAlerts ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
							<template>
								<div class="collapsible-heading p-0">
									<div class="d-flex flex-nowrap bottom-border">
										<div class="collapsible-heading__value" @click="collapseAlerts = !collapseAlerts">
											Warnings
										</div>
										<div class="collapsible-heading__toggle">
											<b-button href="#" variant="collapsible" :class="collapseAlerts ? '' : ' collapsed'" :aria-expanded="collapseAlerts ? 'true' : 'false'" aria-controls="collapseAlerts" @click="collapseAlerts = !collapseAlerts">
												<span class="when-opened">
													<font-awesome-icon icon="chevron-down" />
												</span>
												<span class="when-closed">
													<font-awesome-icon icon="chevron-right" />
												</span>
											</b-button>
										</div>
									</div>
								</div>
								<b-collapse id="collapseAlerts" :visible="collapseAlerts" class="collapse--content">
									<b-col class="mb-3 mt-3">
										Be notified when closures have not been reported at the start or completion times.
									</b-col>
									<b-col class="mb-3">
									<user-notification-setting :setting="'lc-not-closed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'lc-not-opened'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'r-not-placed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'r-not-removed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									</b-col>
								</b-collapse>
							</template>
						</div>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<div :class="collapseReports ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
							<template>
								<div class="collapsible-heading p-0">
									<div class="d-flex flex-nowrap bottom-border">
										<div class="collapsible-heading__value" @click="collapseReports = !collapseReports">
											Reported Opening/Closing of Lanes and Turning Restrictions
										</div>
										<div class="collapsible-heading__toggle">
											<b-button href="#" variant="collapsible" :class="collapseReports ? '' : ' collapsed'" :aria-expanded="collapseReports ? 'true' : 'false'" aria-controls="collapseReports" @click="collapseReports = !collapseReports">
												<span class="when-opened">
													<font-awesome-icon icon="chevron-down" />
												</span>
												<span class="when-closed">
													<font-awesome-icon icon="chevron-right" />
												</span>
											</b-button>
										</div>
									</div>
								</div>
								<b-collapse id="collapseReports" :visible="collapseReports" class="collapse--content">
									<b-col class="mb-3 mt-3">
										Be notified when lanes are reported closed at the start and re-opened at completion.
									</b-col>
									<b-col class="mb-3">
									<user-notification-setting :setting="'lc-closed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'lc-opened'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'r-placed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									<user-notification-setting :setting="'r-removed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
									</b-col>
								</b-collapse>
							</template>
						</div>
					</b-col>
				</b-row>

			<b-row class="notification-settings__playSoundToggle app-only">
			<b-col class="pt-1" md="auto">
			    <label for="toggleMyAlltoggleMyAllSound"><strong>Play a sound for all Push Notifications</strong></label>
			</b-col>
			<b-col md="auto">
			    <div class="on-off-switch-field">
			            <input id="toggleMyAlltoggleMyAllSound" class="on-off-switch" :checked="notifyAllSound"  value="1" type="checkbox" @change="toggleNotifyAllSound()">
			            <label for="toggleMyAlltoggleMyAllSound"></label>
			    </div>
			</b-col>
			</b-row>


	<b-row>
		<b-col sm="12"  lg="6">
		<b-form-group label="Message for User" label-for="edit-lcr__traffic-effect" :state="user.approvalReason.status" :invalid-feedback="user.approvalReason.invalidMessage">
			<p>You can also enter a message that will be included in the email sent to the person requesting the new account. This can be additional instructions, or reason(s) for rejection.</p>
			<b-form-textarea id="edit-lcr__traffic-effect" rows="4" no-resize v-model="user.approvalReason.value" @input="user.approvalReason.resetStatus()" :state="user.approvalReason.status">
			</b-form-textarea>
		</b-form-group>
	</b-col>
	</b-row>

	<b-row>
		<b-col sm="12"  lg="6">
			<b-button variant="primary" class="mr-2" @click="onApprove">Approve New User <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner>
			</b-button>
			<b-button variant="secondary" v-show="user.isApproved.value == 1 || user.isApproved.value == null" @click="onReject">Reject New User <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner>
			</b-button>
		</b-col>
	</b-row>



	<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
		<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
		<ul>
			<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
		</ul>
		<template slot="footer">
			<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
		</template>
	</b-modal>

	<!-- leaving page -->
	<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
		<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
		<template v-slot:modal-footer="{ ok }">
			<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
			<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
			<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
		</template>
	</b-modal>


</b-form>
</b-container>
<Spinner v-else />
</div>
</template>


<script>
import AppUserRequest from '../../../models/AppUserRequest';
import User from '../../../models/User';
import Autocomplete from '@trevoreyre/autocomplete-vue'
import BootstrapField from '../../../utility/BootstrapField';
import ErrorHandler from '../../../utility/ErrorHandler';
// import { VuePassword } from '../../../components/vue-password'
import Format from '../../../utility/Format';
import GoBack from '../../../components/GoBack.vue';
import { VueSelectGrouped } from '../../../components/vue-select-grouped';
import UserNotificationSetting from '../../../components/UserNotificationSetting.vue';
import Spinner from "./../../../components/Spinner.vue";

import Vue from 'vue'

export default {
  name: 'EditAppUserRequest',
  docTitle: "New Account Request - Lane Closures",

  components: {
	Autocomplete,
	// VuePassword,
	VueSelectGrouped,
	GoBack,
	Spinner,
	UserNotificationSetting,
  },
  props:['id'],
  data() {
	return {
		AppUserRequest,
		User,
		Format,
		showNewPrimary:false,
		editedUsername: 'INITIAL__DATA',
		organizationPrefix:new BootstrapField({
		      value: ""}),
		editedDomain:"INITIAL__DATA",
		collapseLcrUpdateNotifications: false,
		collapseReports: false,
		collapseAlerts: false,
		collapseReminders: false,
		collapseViolations: false,
		collapseOrganizationRequests:false,
		collapseMyRequests:false,
		collapseLcrUpdateNotificationsAll: false,
		collapseReportsAll: false,
		collapseAlertsAll: false,
		collapseRemindersAll: false,
		collapseViolationsAll: false,
		collapseOrganizationRequestsAll:false,
		collapseMyRequestsAll:false,
		user: null,
		saving:false,
		organizations: [],
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
		reason:new BootstrapField({
					value: null,
		}),
		errorMsg: null,
		showUnsavedChangesModal:false,
		lineIndexError:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		selectSupervisor:new BootstrapField({
					value: null,
		}),
		selectAlternate:new BootstrapField({
					value: null,
		}),
		selectAway:new BootstrapField({
					value: null,
		}),
		loaded: false,
		showRequiredFieldModal: false,
		requesterProjectIdOptions: [],
		supervisor: null,
		alternateContact: null,
		awayInfo: null,
		refSearchSupervisor: null,
		refSearchAlternate: null,
		refSearchAway: null,
		show: true,
		showNewOrganizationModal: false,
		organizationInfo:null,
		passwordFieldType:"password",
		passwordStrength:0,
		confirmPasswordStrength:0,
		organizationSuffix:null,
		usernamePrefix:new BootstrapField({
					value: null, required:true,
					validator: function(value) {
						if (value == null || value == "null" || value == "") {
							return false;
						}
						return true;
					},
					invalidMessage: 'Please enter username',
				}),
	}
	},
	mounted() {
		this.LoadData();
		this.$nextTick(() => {
		})
   },
	computed: {
		hideWeb: function() {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
				return false;
			}
			return true;
		},
		notifyAllSound() {
			if (this.user) {
				if (this.user.notificationSetting) {
					for (var x = 0; x < this.user.notificationSetting.value.length; x++) {
						if (this.user.notificationSetting.value[x]) {
							if (
								this.user.notificationSetting.value[x].notifySoundMyLcr == 0 ||
								this.user.notificationSetting.value[x].notifySoundAllLcr == 0) {
								return false;
							}
						}
					}
				}
			}
		    return true;
		},

	},
	watch: {
		'user.organizationId.value':function() {
			this.calculateUserName();
		},
		'usernamePrefix.value':function() {
			this.calculateUserName();
		},
		'editedDomain':function() {
			this.calculateUserName();
		},
		'user.domain.value':function() {
			this.calculateUserName();
		},
		'user.phone.value':function() {
		}
	},
  methods: {
    toggleNotifyAllSound() {
    	if (this.user) {
    		if (this.user.notificationSetting) {
    			var x = 0;
    			if(this.notifyAllSound) {
	    			for (x = 0; x < this.user.notificationSetting.value.length; x++) {
					this.user.notificationSetting.value[x].notifySoundMyLcr = 0;
					this.user.notificationSetting.value[x].notifySoundAllLcr = 0;
	    			}
    			} else {
	    			for (x = 0; x < this.user.notificationSetting.value.length; x++) {
					this.user.notificationSetting.value[x].notifySoundMyLcr = 1;
					this.user.notificationSetting.value[x].notifySoundAllLcr = 1;
	    			}
	    		}
    		}
    	}
    },



  	onPhoneFocus:function() {
  		if (this.user.phone.value == null || this.user.phone.value == "") {
  			setTimeout(function(){
  			      document.getElementById('editUserRequestUserPhone').value = "1-";
  			      document.getElementById('editUserRequestUserPhone').selectionStart = document.getElementById('editUserRequestUserPhone').value.length;
  			      document.getElementById('editUserRequestUserPhone').selectionEnd = document.getElementById('editUserRequestUserPhone').value.length;
  			    },1);  // call the function after 50ms
  		}
  	},
  	onPhoneBlur:function() {
  		if (this.user.phone.value == "1-" || document.getElementById('editUserRequestUserPhone').value == "1-") {
  			this.user.phone.value = null;
  			setTimeout(function(){
  			    document.getElementById('editUserRequestUserPhone').value = null;
  			},1);  // call the function after 50ms
  		}
  	},
  	onAltPhoneFocus:function() {
  		if (this.user.altPhone.value == null || this.user.altPhone.value == "") {
  				// this.user.altPhone.value = "1-";
  			setTimeout(function(){
  			      document.getElementById('editAppUserRequestUserAltPhone').value = "1-";
  			      document.getElementById('editAppUserRequestUserAltPhone').selectionStart = document.getElementById('editAppUserRequestUserAltPhone').value.length;
  			      document.getElementById('editAppUserRequestUserAltPhone').selectionEnd = document.getElementById('editAppUserRequestUserAltPhone').value.length;
  			    },1);  // call the function after 50ms

  		}
  	},
  	onAltPhoneBlur:function() {
  		if (this.user.altPhone.value == "1-" || document.getElementById('editAppUserRequestUserAltPhone').value == "1-") {
  			this.user.altPhone.value = null;
  			setTimeout(function(){
  			    document.getElementById('editAppUserRequestUserAltPhone').value = null;
  			},1);  // call the function after 50ms
  		}
  	},
  	togglePrimary: function() {
  		if (this.canCreatePrimaryOrg()) {
	  		if (this.showNewPrimary == true) {
	  			this.showNewPrimary = false;
	  			this.calculateUserName();
	  		} else {
	  			this.showNewPrimary = true;
	  			this.calculateUserName();
	  		}
  		}
  	},
	handleLCKeypress: function(event) {
		if (event.key == " " || event.key == 'PageUp' || event.key == 'PageDown') {
			event.preventDefault();
		}
	},
	setUsernameValidateStyle() {
		document.getElementById('username-editable-content').classList.remove('is-invalid');
		document.getElementsByClassName('lc__username')[0].getElementsByClassName('invalid-feedback')[0].classList.remove('d-block');
		if(this.usernamePrefix.value == '') {
			document.getElementById('username-editable-content').classList.add('is-invalid');
		}
	},
	focusUsernameField(e) {
		document.getElementById('username-prefix').focus();
	},
	setFocusStyle() {
		requestAnimationFrame(() => document.execCommand('selectAll'));
		document.getElementById('username-editable-content').classList.add('focus');
	},
	setNewUsername(e) {
		this.editedUsername = e.target.innerText;
		if (e.target.innerText == "" && e.target.innerHTML != "")  {
			this.editedUsername = e.target.innerHTML;
		}
	},
	removeUsernameFocus() {
		if(this.editedUsername != 'INITIAL__DATA') {
			this.usernamePrefix.value = this.editedUsername.trim();
		} else {
			this.editedUsername = this.usernamePrefix.value;
		}
		this.setUsernameValidateStyle();
		document.getElementById('username-editable-content').classList.remove('focus');
	},
		setDomainValidateStyle() {
	 		document.getElementById('domain-editable-content').classList.remove('is-invalid');
	 		document.getElementsByClassName('lc__domain')[0].getElementsByClassName('invalid-feedback')[0].classList.remove('d-block');
	 		if(this.user.domain.value == '') {
	 			document.getElementById('domain-editable-content').classList.add('is-invalid');
	 		}
	 	},
	 	focusDomainField(e) {
	 		document.getElementById('domain-postfix').focus();
	 	},
	 	setDomainFocusStyle() {
	 		requestAnimationFrame(() => document.execCommand('selectAll'));
	 		document.getElementById('domain-editable-content').classList.add('focus');
	 	},
	 	setNewDomain(e) {
	 		this.editedDomain = e.target.innerText;
	 		if (e.target.innerText == "" && e.target.innerHTML != "")  {
	 			this.editedDomain = e.target.innerHTML;
	 		}
	 	},

	 	removeDomainFocus() {
	 		if(this.editedDomain != 'INITIAL__DATA') {
	 			this.organizationPrefix.value = this.editedDomain.trim();
	 			this.user.domain.value = "@"+this.editedDomain.trim();
	 		} else {
	 			if (this.user.domain.value != null) {
	 				this.editedDomain = this.user.domain.value.replace("@", "");
	 				this.organizationPrefix.value = this.editedDomain.trim();
	 			} else {
	 				this.organizationPrefix.value = null;
	 			}
	 		}
	 		this.setDomainValidateStyle();
	 		document.getElementById('domain-editable-content').classList.remove('focus');
	 	},

	switchPasswordVisibility() {
	this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
	},
	canSetRoles() {
		// cannot set your own roles...
		if (this.$store.getters.userId() == this.id) {
			return false;
		}

		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			return true;
		}
		if (this.$store.getters.userHasRole('agency_admin')) {
			return true;
		}
		return false;
	},
	canCreatePrimaryOrg() {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			return true;
		}
		return false;
	},
	updateNotificationSetting(data) {
		let i = 0;
		if (this.user) {
			if (this.user.notificationSetting) {

				for (i = 0; i < this.user.notificationSetting.value.length; i++) {
					if (this.user.notificationSetting.value[i].notificationTypeId == data.notificationTypeId) {

						if (data.notifyEmailAllLcr == true || data.notifyEmailAllLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyEmailAllLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyEmailAllLcr = 0;
						}
						if (data.notifyEmailMyLcr == true || data.notifyEmailMyLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyEmailMyLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyEmailMyLcr = 0;
						}


						if (data.notifyAppAllLcr == true || data.notifyAppAllLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyAppAllLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyAppAllLcr = 0;
						}
						if (data.notifyAppMyLcr == true || data.notifyAppMyLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyAppMyLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyAppMyLcr = 0;
						}

						if (data.notifySoundAllLcr == true || data.notifySoundAllLcr == 1 ) {
							this.user.notificationSetting.value[i].notifySoundAllLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifySoundAllLcr = 0;
						}
						if (data.notifySoundMyLcr == true || data.notifySoundMyLcr == 1 ) {
							this.user.notificationSetting.value[i].notifySoundMyLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifySoundMyLcr = 0;
						}

						if (data.notifyBrowserAllLcr == true || data.notifyBrowserAllLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyBrowserAllLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyBrowserAllLcr = 0;
						}
						if (data.notifyBrowserMyLcr == true || data.notifyBrowserMyLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyBrowserMyLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyBrowserMyLcr = 0;
						}

					}
				}
			}
		}
	},
	checkRole: function(id) {
		let i = 0;
		if (this.user) {
			if (this.user.roles) {
				for (i = 0; i < this.user.roles.length; i++) {
					if (this.user.roles[i].id == id) {
						this.user.roles.splice(i, 1)
						return true;
					}
					return false;
				}
			}
		}
		return false;
	},
	hasRole: function(id) {
		let i = 0;
		if (this.user) {
			if (this.user.roles) {
				for (i = 0; i < this.user.roles.value.length; i++) {
					if (this.user.roles.value[i].id == id) {
						return true;
					}
					return false;
				}
			}
		}
		return false;
	},

	canAssignRole: function(id) {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			return true;
		} else {
			if (this.$store.getters.userHasRole('agency_admin')) {
				if (id == "agency_user" || id == "agency_admin" || id == "agency_supervisor") {
					return true;
				}
			}
		}
		return false;
	},

	canEditUser() {
		if (this.user) {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
				return true;
			} else {
				if (this.$store.getters.userHasRole('agency_admin')) {
					// verify that the user's organization ID is within this organization
					let userInfo = this.$store.getters.userInfo();
					let editUserInOrg = false;
					let userInOrgTree = false;
					for (let x = 0; x < this.organizations.length; x++) {
						if (this.user.organizationId.getRawValue() == this.organizations[x].id) {
							editUserInOrg = true;
						}
						if (userInfo.organizationId == this.organizations[x].id) {
							userInOrgTree = true;
						}
					}
					if (editUserInOrg == true && userInOrgTree == true) {
						return true;
					}
					return false;
				}
			}
		}
		// return true;
		return false;
	},
	toggleEmailNotification(item) {
		if (item == "toggleEmail") {
			if (this.user.notifyEmailAllLcr.value == 1 && this.user.notifyEmailMyLcr.value == 1) {
				this.user.notifyEmailAllLcr.value = 0;
				this.user.notifyEmailMyLcr.value = 0;
			} else {
				this.user.notifyEmailAllLcr.value = 1;
				this.user.notifyEmailMyLcr.value = 1;
			}
		}
		if (item == "toggleNotifyEmailAllLcr") {
			this.user.notifyEmailAllLcr.value = ! this.user.notifyEmailAllLcr.value;
		}
		if (item == "toggleNotifyEmailMyLcr") {
			this.user.notifyEmailMyLcr.value = ! this.user.notifyEmailMyLcr.value;
		}
	},
	toggleAppNotification(item) {
		if (item == "toggleApp") {
			if (this.user.notifyAppAllLcr.value == 1 && this.user.notifyAppMyLcr.value == 1) {
				this.user.notifyAppAllLcr.value = 0;
				this.user.notifyAppMyLcr.value = 0;
			} else {
				this.user.notifyAppAllLcr.value = 1;
				this.user.notifyAppMyLcr.value = 1;
			}
		}
		if (item == "toggleNotifyAppAllLcr") {
			this.user.notifyAppAllLcr.value = ! this.user.notifyAppAllLcr.value;
		}
		if (item == "toggleNotifyAppMyLcr") {
			this.user.notifyAppMyLcr.value = ! this.user.notifyAppMyLcr.value;
		}
	},
	toggleBrowserNotification(item) {
		if (item == "toggleBrowser") {
			if (this.user.notifyBrowserAllLcr.value == 1 && this.user.notifyBrowserMyLcr.value == 1) {
				this.user.notifyBrowserAllLcr.value = 0;
				this.user.notifyBrowserMyLcr.value = 0;
			} else {
				this.user.notifyBrowserAllLcr.value = 1;
				this.user.notifyBrowserMyLcr.value = 1;
			}
		}
		if (item == "toggleNotifyBrowserAllLcr") {
			this.user.notifyBrowserAllLcr.value = ! this.user.notifyBrowserAllLcr.value;
		}
		if (item == "toggleNotifyBrowserMyLcr") {
			this.user.notifyBrowserMyLcr.value = ! this.user.notifyBrowserMyLcr.value;
		}
	},
	toggleSoundNotification(item) {
		if (item == "toggleSound") {
			if (this.user.notifySoundAllLcr.value == 1 && this.user.notifySoundMyLcr.value == 1) {
				this.user.notifySoundAllLcr.value = 0;
				this.user.notifySoundMyLcr.value = 0;
			} else {
				this.user.notifySoundAllLcr.value = 1;
				this.user.notifySoundMyLcr.value = 1;
			}
		}
		if (item == "toggleNotifySoundAllLcr") {
			this.user.notifySoundAllLcr.value = ! this.user.notifySoundAllLcr.value;
		}
		if (item == "toggleNotifySoundMyLcr") {
			this.user.notifySoundMyLcr.value = ! this.user.notifySoundMyLcr.value;
		}
	},
	setOrganization(val) {
		let x = 0;
		if (typeof val == "object") {
		for (x = 0; x < this.organizations.length; x++) {
				if (val) {
			if (val.id == 	this.organizations[x].id) {

				this.organizationInfo = this.organizations[x];
			}
		}
			}
		} else {
		for (x = 0; x < this.organizations.length; x++) {
			if (val == 	this.organizations[x].id) {
				this.organizationInfo = this.organizations[x];
			}
		}
		}
	},
		getLevelClassName(level) {
		return "level-"+level;
	},
	getFlatTree(option) {
		if (option) {
		if (option.namePath) {
			return Format.pipesToFlatTree(option.namePath);
		} else {
			return option.name;
		}
		}
		return null;
	},

	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},
	calculateUserName() {
		if (this.user) {
			if (this.showNewPrimary) {
				this.user.username.value = this.usernamePrefix.value + this.user.domain.value;
				this.organizationSuffix = this.user.domain.value;
			} else {
				if (this.user && this.user.organizationId.value) {
					this.user.username.value = this.usernamePrefix.value + this.user.organizationId.value.domain;
					this.organizationSuffix = this.user.organizationId.value.domain;
				} else {
					this.user.username.value = this.usernamePrefix.value;
					this.organizationSuffix = "@";
				}
			}
		}
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

		removeAlternateContact(index) {
			this.alternateContact.splice(index, 1);
		},


		SearchSupervisor(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/assignable/?q='+encodeURI(input))
					.then(resp => {
						resolve(resp.data)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		SearchSupervisorValue(result) {
			return result.firstName
		},
		// Addeds a transaction line with contact attached.
		HandleSelectSupervisor(selected) {
			if (selected) {

				this.supervisor = selected;
				this.user.supervisorUserId.value = parseInt(selected.userId);
				this.$refs.searchSupervisor.value = "";
				/*
				if (this.user.id == selected.userId) {
					this.$refs.searchSupervisor.value = "";
				} else {
					this.supervisor = selected;
					this.user.supervisorUserId.value = parseInt(selected.userId);
					this.$refs.searchSupervisor.value = "";
				}
				*/
			}
		},



		SearchAlternate(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/assignable/?q='+encodeURI(input))
					.then(resp => {
						resolve(resp.data)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		SearchAlternateValue(result) {
			return result.firstName
		},
		// Addeds a transaction line with contact attached.
		HandleSelectAlternate(selected) {
			if (selected) {
			if (this.user.id == selected.userId) {
				this.$refs.searchAlternate.value = "";
			} else {
				this.alternateContact = selected;
				this.user.alternateUserId = parseInt(selected.userId);
				this.$refs.searchAlternate.value = "";
			}
			}
		},


		onSubmit(evt) {
			evt.preventDefault()
			let that = this;
			if (that.editedUsername.trim() != "INITIAL__DATA") {
				that.user.username.value = that.editedUsername.trim()+that.organizationSuffix;
			}
			that.setUsernameValidateStyle();
			if (this.validateFields()) {
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.Save(that.user);
			});
			}
		},
		onRemoveSupervisor() {
			this.supervisor = null;
			this.user.supervisorUserId = null;
		},
		onRemoveAlternateContact() {
			this.alternateContact = null;
			this.user.alternateUserId = null;
		},

		onApprove(evt) {
			let that = this;
			evt.preventDefault()
			if (!this.validateFields()) {
				return false;
			}
			this.user.isApproved.value = 1;

			// If they are creating new organization, make sure we don't pass it to the api.
			if (this.showNewPrimary) {
				this.user.organizationId.value = null;
			}
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.Save(that.user);
			});

		},
		onReject(evt) {
			evt.preventDefault()
			if (!this.validateFields()) {
				return false;
			}
			let that = this;
			this.user.isApproved.value = 0;
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.Save(that.user);
			});

		},



		onReset(evt) {
			evt.preventDefault()
			this.show = false
			this.$nextTick(() => {
			this.show = true
			})
		},
		Save(t) {
			if (t instanceof AppUserRequest) {
				let go = true;
				if (go) {
				Vue.prototype.$http({
					method: 'put',
					url: `${this.$store.state.apiUrl}/user-request/${t.id}/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: t.getRawValue()
				}).then(() => {
					// Handle Success
					this.saveState = 'success';
					this.submissionStatus = 'submission-success';
					this.SaveSuccess();
					this.onSubmitPromiseDeferred.resolve();
				}).catch(error => {
					if (error) {
						this.saveState = 'fail';
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							// this.user.SetErrors(error.response.data);
							this.showErrors(error.response.data.fields);
						} else {
							// ErrorHandler.RedirectToLogin();
						}
						this.onSubmitPromiseDeferred.reject();
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});
				}
			}
		},
		SaveSuccess() {
			this.user.saveChanges();
			this.$router.push('/admin/user-approval-list');
		},

		validateFields() {
			let flag = this.user.validate();
			if (this.usernamePrefix.validate() === false) {
				flag = false;
			}

			if (flag === false) {
				this.errorMsg = "There is a problem with a field above."
			} else {
				this.errorMsg = null;
			}
			return flag;
		},


			LoadData(id = this.id) {
				this.loaded = false;
				// Remove any messages being displayed.
				this.submissionStatus = null;
				this.user = new AppUserRequest();
				this.user.parentId = null;
					this.$store.dispatch('organizationList/loadAssignable', this.$store.getters['organizationList/getParams'])
						.then(() => {
								this.organizations = [];
								this.organizations.push({id:-1,name:"This is the Primary Organization", parentId:null});
								let records = this.$store.getters['organizationList/getRecords'];
								if ( records ) {
									records.forEach( item => {
										this.organizations.push(item);
									})
								}
							})
						.catch( error => console.log('error', error) ); // eslint-disable-line

				if (id && Format.TryParseInt(id) > 0) {
					this.GetData(id);
				}
				else {
					if (this.data) {
						this.user = new AppUserRequest(this.data);
						this.user.saveChanges();
					} else {
						this.user = new AppUserRequest();
						this.user.parentId = null;
					}
					this.loaded = true;
				}
			},

			GetData(id) {
				if (Format.TryParseInt(id)) {
					this.loaded = false;
					Vue.prototype.$http.get(this.$store.state.apiUrl + "/user-request/" + id + "/edit?r=" + Math.round(Math.random() * Math.pow(10, 6)))
					.then(response => {
						this.user = new AppUserRequest(response.data);
						// this.$store.commit('formId', response.data.Id);
						this.loaded = true;
						this.setOrganization(this.user.organizationId.value);
						this.supervisor = response.data.supervisor;
						this.alternateContact = response.data.alternateContact;

						// Set the username prefix...
						let usernameParts = this.user.username.getValue().split("@");
						this.usernamePrefix.value = usernameParts[0];

						if (this.user.organizationId.value == null) {
							this.showNewPrimary	= true;
							this.organizationPrefix.value = usernameParts[1];
							this.editedDomain = usernameParts[1];
						} else {
							this.showNewPrimary	= false;
						}



						this.$nextTick(() => {
							this.GetOrganizations();

						})
					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							if (error.response && error.response.data) {
								this.loaded = false;
								this.transactionStatus = 'load-error';
								this.errorDetails = error.response.data;
							}
						} else {
							ErrorHandler.RedirectToLogin();
						}
					});
				}
			},

		closeNewOrganizationModal() {
			this.showNewOrganizationModal = false;
		},
		openNewOrganizationModal() {
			this.showNewOrganizationModal = true;
		},
		GetOrganizations() {
			this.$store.dispatch('organizationList/loadEditable', {keywords:null})
				.then(() => {
						this.organizations = [];
						let records = this.$store.getters['organizationList/getRecords'];
						if ( records ) {
							records.forEach( item => {
								if (item.isActive == 0) item.name += " (inactive)";
								this.organizations.push(item);
							if (item.id == this.user.organizationId.value) {
								this.user.organizationId.value = item;
							}
							})
						}
						this.loaded = true;
					})
				.catch( error => console.log('error', error) ); // eslint-disable-line
		},


		updatePasswordStrength(password) {
			let has_number    = /\d/.test(password);
			let has_lowercase = /[a-z]/.test(password);
			let has_uppercase = /[A-Z]/.test(password);
			let has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(password);  // eslint-disable-line
			let strength = 0;
			if (has_number) {
				strength++;
			}
			if (has_lowercase) {
				strength++;
			}
			if (has_uppercase) {
				strength++;
			}
			if (has_special) {
				strength++;
			}
			if (password.length < 8) {
				strength = 0;
			}
			this.passwordStrength = strength;
		},

		canEditGroup() {
			return this.$store.getters.userInfo().userId == this.user.id;
		},

		modalOnCancel() {
			this.showUnsavedChangesModal = false;
			if (this.$store.getters.logoutRequested) {
				this.$store.commit('logoutRequested', false);
			}
		},
	}, // end of methods();

	beforeRouteEnter(to, from, next) {
		next(vm => {
			Vue.prototype.$bus.$emit("map:clear", 1);
			Vue.prototype.$bus.$emit("map:toggle", 0);
	});
	},
	beforeRouteLeave(to, from, next) {
		if (this.loaded && this.user.hasChanges()) {
			if (this.overrideUnsavedChanges) {
				next(true);
			} else {
				this.showUnsavedChangesModal = true;
				this.modalOnSave = (function() {
					this.onSubmit().then(() => {
						next(true);
					}).catch(() => {
						next(false);
					});
				}).bind(this);

				this.modalOnLeave = (function() {
					this.showUnsavedChangesModal = false;
					next(true);
				}).bind(this);

				next(false);
			}
		}
		else {
			next(true);
		}
	},

}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>